module.exports = __webpack_public_path__ + "img/kl_jhzr.8be3a6f6.png";